/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

export { execute, defaultFieldResolver, responsePathAsArray } from './execute';
export { getDirectiveValues } from './values';


//////////////////
// WEBPACK FOOTER
// ./node_modules/graphql/execution/index.mjs
// module id = 470
// module chunks = 17